var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRearrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "rearrange"), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.3,3A2,2,0,0,0,40,5V8.9A22,22,0,0,0,7.9,9H6a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V11a2,2,0,0,0-2-2H14.1A17.8,17.8,0,0,1,24,6a18,18,0,0,1,13.4,6H33.1A2.1,2.1,0,0,0,31,13.7,2,2,0,0,0,33,16h9a2,2,0,0,0,2-2V5.1A2.1,2.1,0,0,0,42.3,3ZM14,19H8V13h6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,27H32a2,2,0,0,0-2,2V39a1.8,1.8,0,0,0,.8,1.6A17.2,17.2,0,0,1,24,42a18,18,0,0,1-13.4-6h4.3A2.1,2.1,0,0,0,17,34.3,2,2,0,0,0,15,32H6a2,2,0,0,0-2,2v8.9A2.1,2.1,0,0,0,5.7,45,2,2,0,0,0,8,43V39.1A21.9,21.9,0,0,0,37.9,41H42a2,2,0,0,0,2-2V29A2,2,0,0,0,42,27Zm-8,4h6v6H34Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRearrange);
export default __webpack_public_path__ + "static/media/rearrange.dbd60e44b531adc46d7d8852d2a9558b.svg";
export { ForwardRef as ReactComponent };